<script>
import Layout from '@layouts/main.vue'
import BrandList from '@components/brand-list.vue'
import { setSessionItem } from '@utils/session.js'
import { getClientType} from '@utils/client'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'CouponList',
  page: {
    title: 'クーポン一覧',
    meta: [{ name: 'description', content: 'クーポン一覧' }],
  },
  components: { Layout, BrandList },
  data() {
    console.log(process.env.NODE_ENV)
    return {
     selected:0,
      isGASend: false,
      // host: process.env.API_BASE_URL
      imgUrl: `${process.env.VUE_APP_JAFAPP_HOST}`,
    }
  },
  computed: {
    clientType() {
      return getClientType()
    },
    ...mapState({
      showTag: (state) => state.coupons.showTag,
      coupons: (state) => state.coupons.coupons,
      tags: (state) => state.coupons.tags,
      scrollToTop: (state) => state.coupons.scrollToTop,
      host: (state) => state.env.couponHref,
    }),

  },
  async mounted() {
  },
  async activated() {
    if(!this.isGASend)
    {
      window.dataLayer.push({
        event: 'Webview',
        ap_screen_name: 'JAFナビ_クーポン一覧(埋め込みURL)',
      })
      this.isGASend = true
    }

    if (this.$route.query.brand_id) {
      this.$store.dispatch('coupons/selectBrand', this.$route.query.brand_id)
    }
    // if (this.$route.query.preveiw) {
    //   this.$store.dispatch('coupons/serPreview', this.$route.query.preveiw)
    // }
    const code = this.selected;
    if(code === 0){
      this.$store.dispatch('coupons/setArea', "")
      this.$store.dispatch('coupons/changeToRecommend', "")
      this.fetchRecommend();
    }else{
      this.$store.dispatch('coupons/setArea', code)
      this.$store.dispatch('coupons/setShowTag', true)
      this.fetchRecommend();
    }
  },
  methods: {
    goTagList(searchTagId){
      setSessionItem('PRE_SCREEN_ID', 'SU-11')
      this.$router.push({ name: 'tag-coupon-list', params: { id: searchTagId } })
    },
    async fetchRecommend(){
      if (!this.scrollToTop) {
        const scrollEl = document.getElementById('jaf_container')
        scrollEl.scrollTop = this.$route.meta.containerScrollTop

        try {
          await this.$store.dispatch('coupons/fetchCoupons', false)
        } catch (e) {}
      } else {
        this.$store.dispatch('coupons/restoreScrollToTop')
        try {
          await this.$store.dispatch('coupons/fetchCoupons')
        } catch (e) {}
      }
    },
    // 101 : 北海道,102：東北,103：関東,104：中部,105：関西,106：中国,107：四国,108：九州
    async getCouponList(code){
      var that = this;
      var preCode = this.selected;
      this.selected = code;
      if(code === 0){
        this.$store.dispatch('coupons/setArea', "")
        this.$store.dispatch('coupons/changeToRecommend', "")
        this.fetchRecommend();
      }else{
        this.$store.dispatch('coupons/setArea', code)
        this.$store.dispatch('coupons/setShowTag', true)
        try {
          await this.$store.dispatch('coupons/fetchCoupons')
        } catch (e) {
          that.selected = preCode
        }
      }
    },
    clickCoupon(couponNo) {
      const coupon = this.getCouponData(couponNo)
      window.dataLayer.push({
        event: 'クーポン一覧の埋め込み画面の押下',
        ap_screen_name: 'クーポン一覧の埋め込み画面の押下',
        event_action: coupon.COUPON_SUMMARY + '_' + coupon.COUPON_NAME,
      })
        if (this.clientType !== 2) {
          if (process.env.NODE_ENV === 'production') {
            window.open(
              'https://cdn.jafnavi.jp/coupon/coupon.html?coupon_no=' + couponNo,
              '_blank'
            )
          } else {
            window.open(
              'https://jafapp-kensho.web.app/coupon/coupon.html?coupon_no=' +
                couponNo,
              '_blank'
            )
          }
        }
    },
    getCouponData(couponNo) {
      for(var i = 0;i < this.coupons.length;i++)
      {
        if(this.coupons[i].COUPON_NO == couponNo)
        {
          return this.coupons[i]
        }
      }
    },
    // facilityName(coupon) {
    //   if (!coupon.FACILITIES_INFO[0]) {
    //     return ''
    //   }
    //   return coupon.FACILITIES_INFO[0].FACILITIES_NAME
    // }
  },
}
</script>

<template>
  <Layout>
    <div id="coupon_set">

      <BrandList></BrandList>
      <div :class="$style.area_recommand_box">
        <div
          :class="[
            $style.recommand_box,
            this.selected == 0 ? $style.selected_item : $style.common_item,
          ]"
          @click="getCouponList(0)"
        >イチオシ</div>
        <div :class="$style.area_box">
          <p :class="[this.selected == 101 ? $style.selected_item : $style.common_item]" @click="getCouponList(101)">北海道</p>
          <p :class="[this.selected == 102 ? $style.selected_item : $style.common_item]" @click="getCouponList(102)">東北</p>
          <p :class="[this.selected == 103 ? $style.selected_item : $style.common_item]" @click="getCouponList(103)">関東甲信越</p>
          <p :class="[this.selected == 104 ? $style.selected_item : $style.common_item]" @click="getCouponList(104)">東海・北陸</p>
          <p :class="[this.selected == 105 ? $style.selected_item : $style.common_item]" @click="getCouponList(105)">近畿</p>
          <p :class="[this.selected == 106 ? $style.selected_item : $style.common_item]" @click="getCouponList(106)">中国</p>
          <p :class="[this.selected == 107 ? $style.selected_item : $style.common_item]" @click="getCouponList(107)">四国</p>
          <p :class="[this.selected == 108 ? $style.selected_item : $style.common_item]" @click="getCouponList(108)">九州・沖縄</p>
        </div>
      </div>

      <!-- 検索タグを利用したクーポン企画 -->
      <div v-if="showTag && tags && Object.keys(tags).length > 0" :class="$style.tag_box">
        <div
          v-for="(tag,index) in tags"
          :key="index"
          :class="$style.tag_content_box"
          @click="goTagList(tag.SEARCH_TAG_ID)"
        >
          <div
            v-if="tag.SEARCH_TAG_IMG_PATH"
            :class="$style.tag_image"
            :style="{
              backgroundImage: `url(${tag.SEARCH_TAG_IMG_PATH})`,
            }"
          >
          </div>
          <div v-if="!tag.SEARCH_TAG_IMG_PATH && tag.SEARCH_TAG_NAME" :class="$style.tag_name">
            <p>{{tag.SEARCH_TAG_NAME}}</p>
          </div>
        </div>
      </div>

      <div :id="$style.list_view_area">
        <ul>
          <li
            v-for="coupon in coupons"
            :key="coupon.COUPON_NO"
            :style="{
              backgroundImage: `url(${coupon.COUPON_THUMB_PATH})`,
            }"
          >
            <a @click="clickCoupon(coupon.COUPON_NO)">
              <div :class="$style.subject">
                <p :class="$style.title">
                  <span :class="$style.two_line_clamp">{{
                    coupon.COUPON_SUMMARY
                  }}</span>
                </p>
                <p :class="$style.shop_name">
                  <span :class="$style.one_line_clamp">{{ coupon.COUPON_NAME }}</span>
                </p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '~@assets/css/coupon-list.scss';
</style>
